// TODO: replace with BS badge

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import PropTypes from 'prop-types';
import Tooltip from 'react-bootstrap/Tooltip';

import { augmentClassName } from '../../../utils/GlobalCssProxy';
import styles from './label.module.scss';
import useProfileAppContext from '../../../stores/profile/use-profile-app-context';

const className = augmentClassName(styles);

const colorClasses = {
  blue: 'bg-blue',
  chartBlue: 'chart-blue',
  chartGreen: 'chart-green',
  chartPurple: 'chart-purple',
  chartViolet: 'chart-violet',
  gray: 'bg-gray',
  green: 'bg-green',
  violet: 'bg-violet',
  yellow: 'bg-yellow'
};

const Label = ({ labelColor, labelText, tooltip = '' }) => {
  const colorClass = colorClasses[labelColor] || colorClasses.gray;

  const renderTooltip = props => (
    <Tooltip {...className('label-tooltip')} {...props}>
      {tooltip}
    </Tooltip>
  );

  if (!tooltip) {
    return (
      <span
        {...className(
          colorClass,
          'py-1',
          'px-2',
          'text-center',
          'text-white',
          'label',
          'd-print-inline-block'
        )}
      >
        {labelText}
      </span>
    );
  }
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <span
        {...className(
          colorClass,
          'py-1',
          'px-2',
          'text-center',
          'text-white',
          'label'
        )}
      >
        {labelText}
      </span>
    </OverlayTrigger>
  );
};

Label.propTypes = {
  labelColor: PropTypes.string,
  labelText: PropTypes.string,
  tooltip: PropTypes.string
};

export default Label;
